<template>
  <v-dialog
    data-cy="screenSizeDialogModal"
    :model-value="modalOpen"
    max-width="400"
    persistent
    @update:model-value="modalOpen = $event">
    <v-card class="dialog-card" rounded="xl">
      <v-card-title
        class="dialog-title d-flex align-center bg-background-gray-darken-1">
        <v-icon class="mr-2 mb-1 text-prominent-lighten-1" size="small"
          >mdi-alert-circle</v-icon
        >
        Unsupported Device Size
      </v-card-title>
      <v-card-text class="text-prominent">
        The {{ themeStore.brand }} Platform is optimized for use on desktop
        browsers in full screen, and most full sized tablets in horizontal mode.
        If possible, please adjust the browser size or the orientation of your
        device, or use a device with a larger screen.
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between pb-0">
        <v-checkbox
          v-model="dontShowAgain"
          color="primary"
          label="Don't show this again" />
        <v-btn
          class="px-4 mb-5"
          data-cy="screenSizeDialogDismissBtn"
          variant="text"
          color="primary"
          @click="close()">
          Dismiss
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapStores } from "pinia";
import { useThemeStore } from "@/stores/ThemeStore";

const TABLET_WIDTH = 1124;
const MOBILE_WIDTH = 768;
const LS_KEY = "ScreenSizeCheckerDismissed";

export default {
  name: "ScreenSizeChecker",
  data: () => ({
    isTablet: window.innerWidth < TABLET_WIDTH,
    isMobile: window.innerWidth < MOBILE_WIDTH,
    dismissed: localStorage.getItem(LS_KEY) || sessionStorage.getItem(LS_KEY),
    dontShowAgain: false,
  }),
  computed: {
    ...mapStores(useThemeStore),
    modalOpen() {
      return !this.dismissed && (this.isTablet || this.isMobile);
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.isTablet = window.innerWidth < TABLET_WIDTH;
      this.isMobile = window.innerWidth < MOBILE_WIDTH;
    },
    close() {
      this.dismissed = true;
      if (this.dontShowAgain) {
        localStorage.setItem(LS_KEY, true);
      } else {
        sessionStorage.setItem(LS_KEY, true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-card {
  font-family: Barlow, sans-serif;
  .v-card-text {
    font-size: 14px !important;
  }
  .dialog-title {
    font-family: Barlow-Bold, sans-serif;
  }
}
</style>
